export type { Props as LinkProps } from './Link';
export { Link } from './Link';
